let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("bcujh")).then(() => parcelRequire('4QkEr'));